/* eslint-disable import/order, no-console, eol-last */
import interact from '@interactjs/interact/index'
// eslint-disable-next-line import/no-extraneous-dependencies
import plugin from '@interactjs/actions/drag/plugin'
interact.use(plugin)